import { render, staticRenderFns } from "./car-slider.vue?vue&type=template&id=421c676c"
import script from "./car-slider.vue?vue&type=script&lang=js"
export * from "./car-slider.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CarSliderItem: require('/var/www/components/car/car-slider-item.vue').default})
